import {
	ProductKeys3P,
	type ProductKeys3P as ProductKeys3PType,
} from '@atlassian/rovo-connectors-config/types';

import { is3pProductKey } from '../constants/product-keys';
import {
	type ConnectorSource,
	FULL_CONNECTOR_SOURCE,
	type ThirdPartyConfigsBootstrap,
} from '../constants/schemas/3p-config';
import { hasImpersonatedFullConnector } from './impersonation';

export const isProductImpersonated: (
	product: ProductKeys3PType | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
) => boolean = (
	product: ProductKeys3PType | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	return !!(product && is3pProductKey(product)
		? thirdPartyConfigs[product]?.impersonationEnabled
		: false);
};

export const isSearchResultImpersonated = (
	product: ProductKeys3PType | undefined,
	connectorSource: ConnectorSource | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	if (product !== ProductKeys3P.Sharepoint) {
		return isProductImpersonated(product, thirdPartyConfigs);
	}

	return (
		connectorSource === FULL_CONNECTOR_SOURCE &&
		hasImpersonatedFullConnector(product, thirdPartyConfigs)
	);
};
